import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {getCurrentUserId} from '../../authentication/selectors';
import {MobileFormHeader} from '../../shared/components';
import UserProfileMobileForm from './UserProfileMobileForm';
import {withRouter} from 'react-router';
import {Page, PageBody} from '../../layout/components';
import React, {Component, PropTypes} from 'react';

class UserProfileMobileContainer extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  handleGoBack() {
    const {router} = this.props;
    router.goBack();
  }

  render() {
    const {userId} = this.props;

    return (
      <Page pageClassName="edit-profile-mobile-page">
        <div className="edit-profile-banner" />
        <PageBody>
          <div className="edit-profile-mobile-container">
            <MobileFormHeader title="Edit Profile" onGoBackTouchTap={this.handleGoBack} />
            <div className="edit-profile-mobile-form-container">
              <UserProfileMobileForm userId={userId} submitText="Submit" />
            </div>
          </div>
        </PageBody>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    userId: getCurrentUserId(state),
  };
}

UserProfileMobileContainer.propTypes = {
  router: PropTypes.object.isRequired,
  userId: PropTypes.number.isRequired,
};

export default withRouter(connect(mapStateToProps)(UserProfileMobileContainer));



// WEBPACK FOOTER //
// ./app/features/userProfile/components/UserProfileMobileContainer.js